/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import RadioGroup from '@mui/material/RadioGroup';
import Grid from '@mui/material/Grid';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useLocation } from 'react-router';
import { NumberFormatValues, NumericFormat } from 'react-number-format';
import { useTranslation } from 'react-i18next';

import { FormTitle, FormItem } from 'components/shared';
import UseSubForm from 'hooks/useSubForm';
import {
  AutocompleteElement,
  TextFieldElement
} from 'components/muiInputWrappers';
import { useGlobalContext } from 'context/GlobalContext';
import { ShipmentResponse } from 'api/inventory';
import { Role } from 'helpers/app.config';

import UseServiceShipment from './service';
import ValidateType from './ValidateType';

export type FormFields = {
  id: number;
  originId: number;
  guideNumber: string;
  cost: number;
  currencyId: number;
  statusId: number;
  courierId: number;
  shipmentPriorityId: number;
  originResponsibleId: object;
  destinationResponsibleId: number;
};

type Props = {
  form: UseFormReturn;
  shipment?: ShipmentResponse;
  readOnly?: boolean;
  setParamsProducts?: (data: {
    selectOrigin: number;
    selectDestiny: number;
  }) => void | null;
  isSuccess?: boolean;
  name?: string;
  sendActive: number;
  setSendActive: (a: number) => void;
};

function ShipmentInventoryItems({
  form,
  shipment,
  setParamsProducts = null,
  isSuccess = false,
  name = 'shipment',
  sendActive,
  setSendActive
}: Props) {
  const { control } = UseSubForm<FormFields>({
    form,
    name
  });

  const costWatcher = form.watch('cost');
  const selectOrigin = form.watch('originResponsibleId');
  const selectDestiny = form.watch('destinationResponsibleId');

  const { hasAccess } = useGlobalContext();
  const { t } = useTranslation('global');

  const [origen, setOrigen] = useState([]);
  const [destiny, setDestiny] = useState([]);

  const [origenWareHouseAndWareHouse, setOrigenWareHouseAndWareHouse] =
    useState(null);
  const [origenWareHouseAndForce, setOrigenWareHouseAndForce] = useState(null);
  const [origenForceAndForce, setOrigenForceAndForce] = useState(null);
  const [origenForceAndWareHouse, setOrigenForceAndWareHouse] = useState(null);
  const [valueRadioButton, setValueRadioButton] = useState<string | number>(
    null
  );

  const currentPath = useLocation().pathname;

  const {
    originWarehouses,
    orgintaskForce,
    destinationForceIdById,
    destinationWareHouseById,
    destinationEngennierById,
    destinationWarehousesById,
    isFetchingOriginWarehouses,
    currencyOptions,
    couriersOptions,
    shipmentPriorityOptions,
    dataUserActive
  } = UseServiceShipment({
    origenWareHouseAndDestinyWareHouse: origenWareHouseAndWareHouse,
    origenWareHouseAndDestinyForce: origenWareHouseAndForce,
    origenForceAndDestinyForce: origenForceAndForce,
    origenForceAndDestinyWareHouse: origenForceAndWareHouse
  });

  const onSetForm = () => {
    const add = orgintaskForce.filter(
      (item) => item.userId === dataUserActive?.userId
    );

    form.setValue(
      'originResponsibleId',
      // Se agrego esta validacion para que si sos ing, obtengas los datos desde el TOKEN
      Role.ENG
        ? {
            label: add.find((eng) => eng.userId === dataUserActive?.userId)
              .fullName,
            id: dataUserActive?.userId,
            idResponsable: dataUserActive?.responsibleId
          }
        : {
            label: add[0]?.fullName,
            id: add[0]?.userId,
            idResponsable: add[0]?.responsibleId
          }
    );
  };

  const geTypeSend = (type: string) => {
    form.resetField('originResponsibleId');
    form.resetField('destinationResponsibleId');
    setValueRadioButton(type);
    setParamsProducts(null);
    setOrigen([]);
    setDestiny([]);
    setOrigenWareHouseAndWareHouse(null);
    setOrigenWareHouseAndForce(null);
    setOrigenForceAndForce(null);
    setOrigenForceAndWareHouse(null);
    switch (type) {
      // origen almacen y destino almacen
      case '1':
        setSendActive(1);
        setOrigen(
          !hasAccess([Role.ADM]) && !hasAccess([Role.WAD])
            ? []
            : originWarehouses
        );
        break;
      // origen almacen y destino fuerza de trabajo
      case '2':
        setSendActive(2);
        setOrigen(
          !hasAccess([Role.ADM]) && !hasAccess([Role.WAD])
            ? []
            : originWarehouses
        );

        break;
      // origen fuerza de trabajo y destino fuerza de trabajo
      case '3':
        setSendActive(3);
        setOrigen(orgintaskForce);
        if (hasAccess([Role.ENG])) onSetForm();
        break;
      // origen fuerza de trabajo y destino almacen
      case '4':
        setSendActive(4);
        setOrigen(orgintaskForce);
        if (hasAccess([Role.ENG])) onSetForm();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // origen almacen
    if (selectOrigin || !hasAccess([Role.ADM])) {
      form.resetField('destinationResponsibleId');
      switch (sendActive) {
        case 1:
          setOrigenWareHouseAndWareHouse(selectOrigin?.id);
          setOrigenWareHouseAndForce(null);
          setOrigenForceAndForce(null);
          setOrigenForceAndWareHouse(null);
          break;
        case 2:
          setOrigenWareHouseAndWareHouse(null);
          setOrigenWareHouseAndForce(selectOrigin?.id);
          setOrigenForceAndForce(null);
          setOrigenForceAndWareHouse(null);
          break;
        case 3:
          setOrigenWareHouseAndWareHouse(null);
          setOrigenWareHouseAndForce(null);
          setOrigenForceAndForce(selectOrigin?.id);
          setOrigenForceAndWareHouse(null);
          break;
        case 4:
          setOrigenWareHouseAndWareHouse(null);
          setOrigenWareHouseAndForce(null);
          setOrigenForceAndForce(null);
          setOrigenForceAndWareHouse(selectOrigin?.id);
          break;
        default:
          setOrigenWareHouseAndWareHouse(null);
          setOrigenWareHouseAndForce(null);
          setOrigenForceAndForce(null);
          setOrigenForceAndWareHouse(null);
          break;
      }
    }
  }, [form, hasAccess, origen, selectOrigin, sendActive]);

  useEffect(() => {
    switch (sendActive) {
      case 1:
        if (destinationWarehousesById) {
          setDestiny(
            destinationWarehousesById.filter(
              (a: { destinationId: number }) =>
                a.destinationId !== selectOrigin?.id
            )
          );
        }
        break;
      case 2:
        if (destinationWareHouseById) setDestiny(destinationWareHouseById);
        break;
      case 3:
        if (destinationForceIdById)
          setDestiny(
            destinationForceIdById.filter(
              (a: { userId: any }) => a.userId !== selectOrigin?.id
            )
          );
        break;
      case 4:
        if (destinationEngennierById) setDestiny(destinationEngennierById);
        break;
      default:
        break;
    }
    setParamsProducts({
      selectOrigin: selectOrigin?.idResponsable,
      selectDestiny: selectDestiny?.idResponsable
    });
  }, [
    destinationWarehousesById,
    destinationEngennierById,
    destinationForceIdById,
    destinationWareHouseById,
    selectOrigin,
    selectDestiny,
    sendActive
  ]);

  useEffect(() => {
    if (isSuccess) form?.reset();
  }, [isSuccess, form]);

  useEffect(() => {
    if (shipment?.shipmentId) {
      form.setValue('idEdit', shipment?.shipmentId);
      form.setValue('originIdEdit', shipment?.createdUserFullName);
      form?.setValue('format', shipment?.shipmentType);
      form?.setValue(
        'originResponsibleIdEdit',
        shipment?.originResponsibleName
      );
      form?.setValue(
        'destinationResponsibleIdEdit',
        shipment?.destinationResponsibleName
      );
      form?.setValue('cost', shipment?.cost);
      form?.setValue('currencyIdEdit', shipment?.currencyName);
      form?.setValue('guideNumber', shipment?.guideNumber);
      form?.setValue('courierIdEdit', shipment?.courierName);
      form?.setValue('shipmentPriorityIdEdit', shipment?.shipmentPriorityName);
      form?.setValue('statusIdEdit', shipment?.shipmentStateName);
      setValueRadioButton(shipment?.shipmentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipment, shipment?.shipmentId]);

  const isValidate =
    !shipment?.shipmentId ||
    (shipment?.shipmentId && form?.getValues('format'));

  useEffect(() => {
    if (currentPath === '/shipping/create') {
      form.setValue('format', null);
      setValueRadioButton(null);
      form.setValue('cost', '');
    }
  }, [currentPath, form]);

  const MAX_VAL = 9999999.01;
  const withValueCap = ({ value }: NumberFormatValues) => +value < MAX_VAL;

  return (
    <Grid spacing={2} container>
      {shipment?.shipmentId && (
        <Grid lg={4} md={4} sm={12} xs={12} item>
          <FormTitle variant="body2" gutterBottom>
            {t('common.commonProperties.invoice')}
          </FormTitle>
          <FormItem>
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="idEdit"
              required={!!shipment?.shipmentId}
              size="small"
              variant="outlined"
              fullWidth
            />
          </FormItem>
        </Grid>
      )}

      {/* CREADO POR */}

      <Grid lg={6} md={6} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {t('shipment.newShipment.createdBy')}
        </FormTitle>
        <FormItem>
          {shipment?.shipmentId ? (
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="originIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          ) : (
            <TextField
              size="small"
              type="text"
              value={dataUserActive?.fullName}
              variant="outlined"
              disabled
              fullWidth
            />
          )}
        </FormItem>
      </Grid>

      <Grid lg={12} md={12} sm={12} xs={12} item>
        <span style={{ color: '#0E335C', fontWeight: '500', fontSize: '16px' }}>
          {t('shipment.newShipment.selectShipment')}
        </span>
        {isValidate && (
          <Controller
            control={form.control}
            name="format"
            render={({ field: { onBlur } }) => (
              <RadioGroup
                name="format"
                onBlur={onBlur}
                onChange={(_, type) => geTypeSend(type)}
                sx={{
                  color: '#0E335C',
                  fontWeight: '500',
                  '.css-ahj2mt-MuiTypography-root': {
                    fontSize: {
                      xs: '11px',
                      sm: '16px'
                    }
                  }
                }}
                value={valueRadioButton}
                row
              >
                <ValidateType
                  allChecks={hasAccess([Role.ADM, Role.DIS])}
                  disableWhileLoadingData={isFetchingOriginWarehouses}
                  onlyUser={hasAccess([Role.ENG])}
                  onlyWarehouse={hasAccess([Role.WAD])}
                  shipmentId={shipment?.shipmentId}
                  superVisor={hasAccess([Role.SUP])}
                />
              </RadioGroup>
            )}
          />
        )}
      </Grid>

      {/* ORIGEN */}

      <Grid data-testid="origen" lg={6} md={6} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {shipment?.shipmentId ? '' : '*'}
          {t('shipment.newShipment.origin')}
        </FormTitle>
        <FormItem>
          {shipment?.shipmentId ? (
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="originResponsibleIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          ) : (
            <AutocompleteElement
              autocompleteProps={{
                size: 'small',
                renderOption: (props, option) => (
                  <Typography {...props} key={option.id}>
                    {option.label}
                  </Typography>
                ),
                disabled: !!shipment?.shipmentId
              }}
              control={form.control}
              disabled={!!shipment?.shipmentId}
              loading={isFetchingOriginWarehouses}
              name="originResponsibleId"
              options={
                origen?.map((origin) => ({
                  label: `${origin?.warehouseName || origin?.taskForceName}${
                    origin.enabled === false
                      ? ` (${t('common.commonProperties.inactive')})`
                      : ''
                  }`,
                  id: origin?.warehouseId || origin?.taskkForceId,
                  idResponsable: origin?.responsibleId
                })) || []
              }
              required
            />
          )}
        </FormItem>
      </Grid>

      {/* DESTINO */}

      <Grid data-testid="destino" lg={6} md={6} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {shipment?.shipmentId ? '' : '*'}
          {t('shipment.newShipment.destination')}
        </FormTitle>
        <FormItem>
          {shipment?.shipmentId ? (
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="destinationResponsibleIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          ) : (
            <AutocompleteElement
              autocompleteProps={{
                size: 'small',
                disabled: !!shipment?.shipmentId
              }}
              control={form.control}
              disabled={!!shipment?.shipmentId}
              loading={isFetchingOriginWarehouses}
              name="destinationResponsibleId"
              options={
                destiny?.map((destino) => ({
                  label:
                    destino?.name ||
                    destino?.destinationName ||
                    destino?.warehouseName ||
                    destino?.taskForceName ||
                    destino?.fullName,
                  id:
                    destino?.destinationId ||
                    destino?.warehouseId ||
                    destino?.taskkForceId ||
                    destino?.userId,
                  idResponsable: destino?.responsibleId
                })) || []
              }
              required
            />
          )}
        </FormItem>
      </Grid>

      {/* COSTO */}

      <Grid lg={6} md={6} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {t('common.commonProperties.cost')}
        </FormTitle>
        <FormItem>
          <Controller
            control={form?.control}
            name="cost"
            render={({
              field: { onChange, onBlur, value },
              fieldState: { error }
            }) => (
              <NumericFormat
                allowNegative={false}
                className="numericFormat"
                customInput={TextField}
                decimalScale={2}
                disabled={!!shipment?.shipmentId}
                displayType="input"
                error={!!error}
                helperText={error?.message}
                isAllowed={withValueCap}
                name="cost"
                onBlur={onBlur}
                onValueChange={(values) => {
                  onChange(values?.floatValue || '');
                }}
                thousandSeparator=","
                value={value}
                allowLeadingZeros
                valueIsNumericString
              />
            )}
          />
        </FormItem>
      </Grid>
      {/* MONEDA */}

      <Grid lg={6} md={6} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {shipment?.shipmentId ? '' : '*'}
          {t('configurationComponent.headers.currency')}
        </FormTitle>
        <FormItem>
          {shipment?.shipmentId ? (
            <TextFieldElement
              control={form.control}
              disabled={!!shipment?.shipmentId}
              name="currencyIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          ) : (
            <AutocompleteElement
              autocompleteProps={{
                size: 'small',
                disabled: !!shipment?.shipmentId
              }}
              control={control}
              name="currencyId"
              options={
                currencyOptions?.map((costOption) => ({
                  label: costOption?.name,
                  id: costOption?.id
                })) || []
              }
              rules={{
                validate: {
                  required: (value) => {
                    if (!!costWatcher && !value)
                      return t('shipment.newShipment.requiredFieldIfCost');
                    return true;
                  }
                }
              }}
              matchId
              required
            />
          )}
        </FormItem>
      </Grid>

      {/* TIPO DE CAMBIO */}

      <Grid lg={4} md={4} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {shipment?.shipmentId ? '' : '*'}
          {t('shipment.newShipment.guideNumber')}
        </FormTitle>
        <FormItem>
          <TextFieldElement
            control={control}
            disabled={!!shipment?.shipmentId}
            name="guideNumber"
            size="small"
            type="text"
            validation={{
              pattern: {
                value: /^[a-zA-Z0-9\s-ñÑáÁéÉíÍóÓúÚ]*$/,
                message: 'Campo alfanúmerico'
              }
            }}
            variant="outlined"
            fullWidth
            required
          />
        </FormItem>
      </Grid>

      {/* SERVICIO DE MENSAJERIA */}

      <Grid lg={4} md={4} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {shipment?.shipmentId ? '' : '*'}
          {t('shipment.newShipment.courier')}
        </FormTitle>
        <FormItem>
          {shipment?.shipmentId ? (
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="courierIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          ) : (
            <AutocompleteElement
              autocompleteProps={{
                size: 'small',
                disabled: !!shipment?.shipmentId
              }}
              control={control}
              name="courierId"
              options={
                shipment?.shipmentId
                  ? [
                      {
                        label: shipment?.courierId,
                        id: shipment?.courierName
                      }
                    ]
                  : couriersOptions?.map((costOption) => ({
                      label: costOption?.description,
                      id: costOption?.id
                    })) || []
              }
              matchId
              required
            />
          )}
        </FormItem>
      </Grid>

      {/* PRIORIDAD */}

      <Grid lg={4} md={4} sm={12} xs={12} item>
        <FormTitle variant="body2" gutterBottom>
          {shipment?.shipmentId ? '' : '*'}
          {t('common.commonProperties.priority')}
        </FormTitle>
        <FormItem>
          {shipment?.shipmentId ? (
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="shipmentPriorityIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          ) : (
            <AutocompleteElement
              autocompleteProps={{
                size: 'small',
                disabled: !!shipment?.shipmentId
              }}
              control={control}
              name="shipmentPriorityId"
              options={
                shipment?.shipmentId
                  ? [
                      {
                        label: shipment?.shipmentPriorityId,
                        id: shipment?.shipmentPriorityName
                      }
                    ]
                  : shipmentPriorityOptions?.map((costOption) => ({
                      label: costOption?.description,
                      id: costOption?.id
                    })) || []
              }
              matchId
              required
            />
          )}
        </FormItem>
      </Grid>

      {/* ESTATUS */}

      {!!shipment?.shipmentId && (
        <Grid lg={12} md={12} sm={12} xs={12} item>
          <FormTitle variant="body2" gutterBottom>
            {t('common.commonProperties.status')}
          </FormTitle>
          <FormItem>
            <TextFieldElement
              control={control}
              disabled={!!shipment?.shipmentId}
              name="statusIdEdit"
              size="small"
              variant="outlined"
              fullWidth
            />
          </FormItem>
        </Grid>
      )}
    </Grid>
  );
}

export default ShipmentInventoryItems;
